// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__2328Y","colMaxWidth":"Table_colMaxWidth__KLb13"};